import { useEffect, useRef } from 'react'
import { homeStatus } from '../../redux/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { fetchHome } from '../../redux/reducers'
import HomePopularProducts from './components/popular-products'
import HomeAddress from './components/home-address/home-address'
import HomeCatalog from './components/home-catalog'
import HomeSlider from './components/home-slider'
import HomeAbout from './components/home-about'
import Loader from '../../components/loader/loader'
import './styles/index.scss'


const Home = () => {
   const ref = useRef()
   const dispatch = useDispatch()
   const status = useSelector(homeStatus)

   useEffect(() => {
      dispatch(fetchHome())
   }, []) //eslint-disable-line

   useEffect(() => {
      status === 'success' &&  ref.current.scrollIntoView(true)
   }, [status])

   if (status === 'loading') return <Loader />

   return (
      <div ref={ref}>
         <HomeSlider />
         <HomeAddress />
         <HomeCatalog />
         <HomePopularProducts />
         <HomeAbout />
      </div>
   )
}

export default Home
